export default __webpack_public_path__ + "static/media/WNo.7-0.412915b9.jpg";